export default __webpack_public_path__ + "images/4cdcc5496d34f19c6b340f3711aba05d-senior_citizen.webp";